/* eslint-disable react/prop-types */
import Footer from '@layout/Footer/BaseFooter/Footer';
import AboutUs from '@comp/AboutUs/AboutUs';
import styled from 'styled-components';
import H1 from '@base/H1/H1';
import imageHelper from '@utils/imageHelper';
import SEO from '@seo/index';

const Layout = styled.div`
  width: 1136px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  @media (max-width: 70.95em) {
    width: 100%;
    padding: 0 16px;
    grid-template-columns: repeat(24, 1fr);
    grid-column-gap: 8px;
  }
  @media (max-width: 70.95em) {
    padding: 0;
    grid-column-gap: 8px;
    grid-row-gap: 8px;
  }
`;

const LogoContainer = styled.div`
  width: 1136px;
  margin: auto;
  z-index: 1;
  height: 56px;
  @media (max-width: 70.95em) {
    width: 100%;
  }
`;

const Logo = styled.img`
  position: absolute;
  top: 24px;
  @media (max-width: 70.95em) {
    width: 115px;
    height: 18px;
    left: 16px;
  }
`;

const Video = styled.video`
  width: 100%;
  object-fit: cover;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
`;

const Header = styled.header`
  position: relative;
  height: 100vh;
`;
const HeaderContent = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  position: absolute;
  bottom: 40px;
`;

const HeadLine = styled(H1)`
  font-size: 56px;
  color: #fff;
  width: 705px;
  z-index: 1;
  margin-top: 16px;
  @media (max-width: 70.95em) {
    font-size: 24px;
    line-height: 36px;
    text-align: center;
    width: auto;
    color: #000;
  }
  @media (max-width: 70.95em) {
    color: #fff;
    font-size: 24px;
    line-height: 150%;
  }
`;

const Tags = styled.div`
  padding: 12px 24px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(80px);
  border-radius: 8px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 2px;
  @media (max-width: 70.95em) {
    font-size: 12px;
    letter-spacing: 1.2px;
    text-align: center;
    padding: 12px 16px;
    backdrop-filter: blur(44px);
  }
`;

const StyledFooter = styled(Footer)`
  @media (max-width: 70.95em) {
    margin-top: 0;
  }
`;

const AboutUsLanding = () => {
  return <AboutUs />;
};

const title = 'About Us | Unacademy';
const url = 'https://unacademy.com/about';
const description =
  'Prepare for examinations and take any number of courses from various topics on Unacademy - an education revolution';

const PageLayout = ({ children }) => (
  <>
    <SEO
      title="About Us | Unacademy"
      description={description}
      url={url}
      openGraph={{ title, description, url }}
    />
    <Header>
      <Video loop muted autoPlay playsInline>
        <source
          src="https://quark.uacdn.net/acquisition/AboutUsHeader--compressed.webm"
          type="video/webm"
        />
        <source
          src="https://quark.uacdn.net/acquisition/AboutUsHeader--compressed.mp4"
          type="video/mp4"
        />
      </Video>
      <LogoContainer>
        <Logo src={imageHelper.getImage('un_white_logo.svg')} alt="logo" />
      </LogoContainer>
      <HeaderContent>
        <Tags>EDUCATE • ENABLE • EMPOWER</Tags>
        <HeadLine>Unacademy is India’s largest online learning app</HeadLine>
      </HeaderContent>
    </Header>

    <Layout>{children}</Layout>

    <StyledFooter display />
  </>
);

AboutUsLanding.Layout = PageLayout;

AboutUsLanding.pageInfo = {
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    disableDarkMode: true
  }
};

export default AboutUsLanding;
